// import React, {Fragment} from 'react'
import { Outlet } from "react-router-dom";

//Navs & Footer
import PrimaryNav from "../components/nav/PrimaryNav";
import SecondaryNav from "../components/nav/SecondaryNav";
import Footer from "../components/nav/Footer";

const Layout = () => {
  return (
    <>
      <main>
        <PrimaryNav />
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default Layout;
